module.exports = __webpack_public_path__ + "img/ledger.10263483.svg";